<template>
  <div class="notice-management">
    <!-- 页面头部 -->
    <div class="common-level-rail">
      <h2>采购管理</h2>
      <div class="right-buttons">
        <el-button size="small" icon="el-icon-back" @click="goBack">返回</el-button>
        <el-button size="small" icon="el-icon-plus" type="primary" @click="addNotice">添加采购</el-button>
      </div>
    </div>

    <!-- 搜索区域 -->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="">
          <el-input v-model="searchForm.title" placeholder="采购标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 采购列表 -->
    <div class="table-wrap">
      <el-table size="small" :data="noticeList" border style="width: 100%" v-loading="loading">
        <el-table-column prop="title" label="采购标题" min-width="200">
          <template slot-scope="scope">
            <span class="notice-title" @click="viewNotice(scope.row)">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="180"></el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="editNotice(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="deleteNotice(scope.row)" type="text" size="small" style="color: #f56c6c;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber">
      </el-pagination>
    </div>

    <!-- 添加/编辑采购弹窗 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="800px"
      :close-on-click-modal="false">
      
      <el-form :model="noticeForm"  ref="noticeForm" label-width="100px">
        <el-form-item label="采购标题" prop="title">
          <el-input 
            v-model="noticeForm.name" 
            placeholder="请输入采购内容：某某企业 几年几月 采购了什么"
            maxlength="100"
            show-word-limit>
          </el-input>
        </el-form-item>
        
        
        <el-form-item label="排序" prop="sort">
          <el-input-number 
            v-model="noticeForm.sort" 
            :min="0" 
            :max="999"
            controls-position="right">
          </el-input-number>
          <div class="form-tips">数字越小越靠前</div>
        </el-form-item>
        
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitNotice" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 采购详情弹窗 -->
    <el-dialog 
      title="采购详情" 
      :visible.sync="detailVisible" 
      width="700px">
      <div class="notice-detail">
        <h3 class="detail-title">{{ currentNotice.title }}</h3>
        <div class="detail-meta">
          <span>创建时间：{{ currentNotice.create_time }}</span>
          <span style="margin-left: 20px;">状态：{{ currentNotice.status ? '启用' : '禁用' }}</span>
        </div>
        <div class="detail-content">{{ currentNotice.content }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PurchaseApi from '@/api/purchase.js';

export default {
  data() {
    return {
      loading: false,
      submitLoading: false,
      supply_id: 0,
      noticeList: [],
      curPage: 1,
      pageSize: 20,
      totalDataNumber: 0,
      
      // 搜索表单
      searchForm: {
        status: '-1',
        title: ''
      },
      
      // 弹窗控制
      dialogVisible: false,
      detailVisible: false,
      dialogTitle: '添加采购',
      
      // 表单数据
      noticeForm: {
        cg_order_id: 0,
        name:'',
        sort: 50,
        status: 1
      },
      
      // 当前查看的采购
      currentNotice: {},
    
     
    };
  },
  
  created() {
    this.supply_id = this.$route.query.supply_id;
    if (!this.supply_id) {
      this.$message.error('缺少政商企ID');
      this.goBack();
      return;
    }
    this.getNoticeList();
  },
  
  methods: {
    // 获取采购列表
    getNoticeList() {
      this.loading = true;
      const params = {
        ...this.searchForm,
        supply_id: this.supply_id,
        page: this.curPage,
        list_rows: this.pageSize
      };
      
      // 使用现有的SupplyApi，您需要在SupplyApi中添加采购相关的方法
      PurchaseApi.getList(params, true)
        .then(res => {
          this.loading = false;
          if (res.code === 1) {
            this.noticeList = res.data.list.data || [];
            this.totalDataNumber = res.data.list.total || 0;
          } else {
            this.$message.error(res.msg || '获取采购列表失败');
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message.error('获取采购列表失败');
        });
    },
    
    // 搜索
    onSearch() {
      this.curPage = 1;
      this.getNoticeList();
    },
    
    // 添加采购
    addNotice() {
      this.dialogTitle = '添加采购';
      this.noticeForm = {
        cg_order_id: 0,
        title: '',
        content: '',
        sort: 50,
        status: 1
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.noticeForm) {
          this.$refs.noticeForm.clearValidate();
        }
      });
    },
    
    // 编辑采购
    editNotice(row) {
      this.dialogTitle = '编辑采购';
      this.noticeForm = {
        cg_order_id: row.cg_order_id,
        name: row.name,
        sort: row.sort
      };
      this.dialogVisible = true;
    },
    
    // 提交采购
    submitNotice() {
      this.$refs.noticeForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const params = {
            ...this.noticeForm,
            supply_id: this.supply_id
          };
          
          const api = this.noticeForm.cg_order_id ? PurchaseApi.edit : PurchaseApi.add;
          
          api(params, true)
            .then(res => {
              this.submitLoading = false;
              if (res.code === 1) {
                this.$message.success(this.noticeForm.cg_order_id ? '编辑成功' : '添加成功');
                this.dialogVisible = false;
                this.getNoticeList();
              } else {
                this.$message.error(res.msg || '操作失败');
              }
            })
            .catch(error => {
              this.submitLoading = false;
              this.$message.error('操作失败');
            });
        }
      });
    },
    
    // 查看采购详情
    viewNotice(row) {
      this.currentNotice = { ...row };
      this.detailVisible = true;
    },
    
    // 删除采购
    deleteNotice(row) {
      this.$confirm('确定要删除该采购吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        PurchaseApi.delete({
          notice_id: row.cg_order_id
        }, true).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功');
            this.getNoticeList();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        }).catch(error => {
          this.$message.error('删除失败');
        });
      });
    },
    
    // 修改状态
    changeStatus(row) {
      PurchaseApi.changeStatus({
        notice_id: row.cg_order_id,
        status: row.status
      }, true).then(res => {
        if (res.code === 1) {
          this.$message.success('状态修改成功');
        } else {
          this.$message.error(res.msg || '状态修改失败');
          // 恢复原状态
          row.status = row.status ? 0 : 1;
        }
      }).catch(error => {
        this.$message.error('状态修改失败');
        // 恢复原状态
        row.status = row.status ? 0 : 1;
      });
    },
    
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.curPage = 1;
      this.getNoticeList();
    },
    
    handleCurrentChange(val) {
      this.curPage = val;
      this.getNoticeList();
    },
    
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.notice-management {
  padding: 20px;
}

.common-level-rail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.right-buttons {
  display: flex;
  gap: 10px;
}

.notice-title {
  color: #409EFF;
  cursor: pointer;
}

.notice-title:hover {
  text-decoration: underline;
}

.notice-detail {
  padding: 0 10px;
}

.detail-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.detail-meta {
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
}

.detail-content {
  line-height: 1.6;
  min-height: 200px;
  white-space: pre-wrap;
  word-break: break-all;
}

.form-tips {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.table-wrap {
  margin-bottom: 20px;
}

.pagination {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/supply/cg_order/index.vue